export default __webpack_public_path__ + "static/media/Rich Table (6).d543eeac.png";